import { create } from 'zustand';
import { Sections } from 'src/legacy/Components/auth/_constants';

export type AuthModalSection = (typeof Sections)[keyof typeof Sections];
// Resolve uma requisição pendente (retryOnAuth) com as credenciais da
// autenticação. Rejeita quando o usuário fecha/cancela o modal sem autenticar.
export type AuthModalResolver = (response?: unknown) => void;
export type AuthModalRejecter = (reason?: unknown) => void;

export type AuthModalState = {
  defaultSection: AuthModalSection;
  isOpen: boolean;
  closeOnOverlayClick: boolean;
  onOverlayClick: (() => void) | null;
  onOpen: () => void;
  onOpenWithcloseOnOverlayClick: () => void;
  onSignupOverlayLocked: () => void;
  onLogin: () => void;
  onSignup: () => void;
  onClose: () => void;
  onCompleteSingup: () => void;
  setOnOverlayClick: (fn: (() => void) | null) => void;
  setSection: (section: AuthModalSection) => void;
  resolvers: AuthModalResolver[];
  rejecters: AuthModalRejecter[];
  dummyResolver: null;
};

const initialState: Pick<
  AuthModalState,
  'defaultSection' | 'isOpen' | 'closeOnOverlayClick' | 'onOverlayClick'
> = {
  defaultSection: Sections.LOGIN,
  isOpen: false,
  closeOnOverlayClick: false,
  onOverlayClick: null,
};

export const useAuthModal = create<AuthModalState>((set, get) => ({
  ...initialState,
  dummyResolver: null,
  resolvers: [],
  rejecters: [],

  onOpen: () => set({ isOpen: true }),

  onOpenWithcloseOnOverlayClick: () =>
    set({ isOpen: true, closeOnOverlayClick: true }),

  // Abre o cadastro com o overlay travado (clicar fora/ESC não fecha).
  // Usado na criação de evento para evitar saída acidental que derruba a
  // conversão. A saída intencional continua acontecendo pelo botão X, que
  // dispara o onOverlayClick registrado (navega de volta à origem).
  onSignupOverlayLocked: () => {
    const currentOnOverlayClick = get().onOverlayClick;

    set({
      defaultSection: Sections.SIGNUP,
      isOpen: true,
      closeOnOverlayClick: false,
      onOverlayClick: currentOnOverlayClick || (() => get().onClose()),
    });
  },

  onLogin: () => {
    const currentOnOverlayClick = get().onOverlayClick;

    set({
      defaultSection: Sections.LOGIN,
      isOpen: true,
      closeOnOverlayClick: true,
      onOverlayClick: currentOnOverlayClick || (() => get().onClose()),
    });
  },

  onSignup: () => {
    const currentOnOverlayClick = get().onOverlayClick;

    set({
      defaultSection: Sections.SIGNUP,
      isOpen: true,
      closeOnOverlayClick: true,
      onOverlayClick: currentOnOverlayClick || (() => get().onClose()),
    });
  },

  onCompleteSingup: () => {
    const currentOnOverlayClick = get().onOverlayClick;

    set({
      defaultSection: Sections.COMPLETE_SINGUP,
      isOpen: true,
      closeOnOverlayClick: true,
      onOverlayClick: currentOnOverlayClick,
    });
  },

  onClose: () => {
    set(initialState);
  },

  setOnOverlayClick: fn => set({ onOverlayClick: fn }),
  setSection: section => set({ defaultSection: section }),
}));